export const TASK_TYPES = [
  {
    id: 0,
    label: 'New',
    value: 'New',
  },
  {
    id: 1,
    label: 'Pending',
    value: 'Pending',
  },
  {
    id: 2,
    label: 'Send to Support',
    value: 'Send to Support',
  },
  {
    id: 3,
    label: 'Complete',
    value: 'Complete',
  },
];

export const TASK_STATUS_TYPE = {
  Complete: 'Complete',
  SendToSupport: 'Send to Support',
  Pending: 'Pending',
  New: 'New',
};

/**
 * @type {Map<string, {
 *    id: string,
 *    label: string,
 *    value: string,
 * }>}
 */
export const TASK_TYPES_COLLECTION = new Map();
TASK_TYPES.forEach((type) => {
  TASK_TYPES_COLLECTION.set(type.value, type);
});

export const TASKS = () => [
  {
    Id: '00T0500000RyoLCEAZ',
    UpdateToTask: null,
    NoteToHCP: 'Test -call',
    TaskStatus: 'Pending',
    TaskSubtype: 'See Notes',
    TaskType: 'Attention Needed',
    CreatedDate: '2024-10-11T17:57:20.000Z',
    Storefront: 'covidcarenow.com',
    OrderStatus: 'FLAGGED',
    PatientName: 'Radha Shivam',
    PatientId: 4562291,
    DoctorId: 4183530,
    OMSOrderId: '2023110635416098',
    ProductList: ['Azithromycin'],
  },
  {
    Id: '00T0500000RykgdEAB',
    UpdateToTask: null,
    NoteToHCP: 'test from saleforce without changing the doctor',
    TaskStatus: 'Pending',
    TaskSubtype: 'Ella',
    TaskType: 'Priority Order - Review ASAP',
    CreatedDate: '2025-02-11T17:57:20.000Z',
    Storefront: 'GetContrave.com',
    OrderStatus: 'FLAGGED',
    PatientName: 'sadg sadg',
    PatientId: 4558632,
    DoctorId: 4183530,
    OMSOrderId: '2023110635416098',
    ProductList: ['Prescriber Visit', 'Contrave'],
  },
  {
    Id: '00T0500000RylBCEAZ',
    UpdateToTask: null,
    NoteToHCP: 'test',
    TaskStatus: 'Pending',
    TaskSubtype: 'Pt. requested immediate review',
    TaskType: 'Priority Order - Review ASAP',
    CreatedDate: '2025-02-11T19:53:20.000Z',
    Storefront: 'BosleyRx.com',
    OrderStatus: 'Pending M.A.',
    PatientName: 'Radha Shivam',
    PatientId: 4562101,
    DoctorId: 4183530,
    OMSOrderId: '2023110635416098',
    ProductList: ['Finasteride'],
  },
  {
    Id: '00T0500000RylCFEAZ',
    UpdateToTask: null,
    NoteToHCP: 'test3',
    TaskStatus: 'Send to Support',
    TaskSubtype: 'Medical information provided',
    TaskType: 'Priority Order - Review ASAP',
    CreatedDate: '2025-02-11T11:53:20.000Z',
    Storefront: 'BosleyRx.com',
    OrderStatus: 'Pending M.A.',
    PatientName: 'Radha Shivam',
    PatientId: 4562101,
    DoctorId: 4183530,
    OMSOrderId: '2023110635416098',
    ProductList: ['Finasteride'],
  },
  {
    Id: '00T0500000RylthEAB',
    UpdateToTask: null,
    NoteToHCP: 'Test one',
    TaskStatus: 'Pending',
    TaskSubtype: 'Expedited shipping',
    TaskType: 'Priority Order - Review ASAP',
    CreatedDate: '2025-02-11T14:53:20.000Z',
    Storefront: 'UpScriptCare.com',
    OrderStatus: 'Pending M.A.',
    PatientName: 'Radha ji',
    PatientId: 4562071,
    DoctorId: 4183530,
    OMSOrderId: '2025013061935281',
    ProductList: ['Premarin'],
  },
  {
    Id: '00T0500000RyoJ6EAJ',
    UpdateToTask: 'update',
    NoteToHCP: 'note',
    TaskStatus: 'Pending',
    TaskSubtype: 'Ella',
    TaskType: 'Priority Order - Review ASAP',
    CreatedDate: '2025-02-11T14:53:20.000Z',
    Storefront: 'BosleyRx.com',
    OrderStatus: 'FLAGGED',
    PatientName: 'Radha Shivam',
    PatientId: 4562089,
    DoctorId: 4183530,
    OMSOrderId: '2025013117655307',
    ProductList: ['Finasteride'],
  },
];
